import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import React from 'react';
import Typography from '@mui/material/Typography';


const PostulacionRecibida = props => {

    return <Container maxWidth="md">
            <Paper sx={{p: 2}}>
                <Typography variant="h4">Postulación recibida</Typography>
                <Typography variant="body1">
                    Usted ha sido registrado satisfactoriamente en el proceso de convocatoria docente UNIQ.<br/><br/>
                    Se ha enviado una copia de la ficha de postulación al correo consignado en su registro,
                    en caso no lo encuentre revise por favor su bandeja de SPAM
                </Typography>
                <a href="https://uniq.edu.pe">Regresar a la página principal</a>
            </Paper>
        </Container> 
}

export default PostulacionRecibida;
